import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import {
  updateCoverDeviation,
  updateCoverDeviationOffsetY,
  deleteCoverDeviation,
} from '../../../../actions/deviations';
import {
  setIsRepositioning,
  setSelectedDeviation,
} from '../../../../actions/profileHero';
import {
  FirstTimeFlag,
  dropFirstTimeFlag,
} from '@wix/da-shared-react/pkg/redux/firstTimeFlags';
import { getCoverDeviation } from '../../../../selectors/deviations';
import { getIsRepositioning } from '../../../../selectors/profileHero';
import { Props } from './ProfileHeroEditControls';

export type StateProps = Pick<
  Props,
  'coverDeviation' | 'isRepositioning' | 'showWatchIntro'
>;
export type DispatchProps = Pick<
  Props,
  | 'setIsRepositioning'
  | 'setSelectedDeviation'
  | 'updateCoverDeviation'
  | 'deleteCoverDeviation'
  | 'updateCoverDeviationOffsetY'
  | 'dropProfileEditAidFlag'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const coverDeviation = getCoverDeviation(state);
  const showWatchIntro =
    !ownProps.showProfileHeroAid && ownProps.showProfileEditAid;

  return {
    coverDeviation,
    isRepositioning: getIsRepositioning(state),
    showWatchIntro,
  };
};
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  setIsRepositioning,
  setSelectedDeviation,
  updateCoverDeviation,
  deleteCoverDeviation,
  updateCoverDeviationOffsetY,
  dropProfileEditAidFlag: () =>
    dropFirstTimeFlag({ flag: FirstTimeFlag.ProfileEditAidNotClosed }),
};

export default connect(mapStateToProps, mapDispatchToProps);
